module.exports = __webpack_public_path__ + "static/media/history.8577c99b.svg";